<template>
  <div id="wrap">
    <!-- 본문 영역 시작-->
    <div id="contract_container">
      <div class="contract_contents">
        <div>
          <img src="../../assets/img/pass4.png" alt="가입" />
          <h2>서비스 가입하기</h2>
          <h3>가입하시는 분의 정보를 정확히 입력하시기 바랍니다.</h3>
          <v-form v-model="valid" ref="form" onsubmit="return false;">
            <fieldset>
              <table>
                <tr style="height: 50px">
                  <th><label for="telecom">통신사</label></th>
                  <td>
                    <v-radio-group v-model="teleCoCd" @click.stop="chkClear()" hide-details row>
                      <v-radio label="SKT" value="1"></v-radio>
                      <v-radio label="KT" value="2"></v-radio>
                      <v-radio label="LGU+" value="3"></v-radio>
                    </v-radio-group>
                  </td>
                </tr>
                <tr>
                  <th>
                    <label for="tel">휴대폰번호</label>
                  </th>
                  <td>
                    <v-text-field
                      style="min-width:200px;"
                      ref="cellTelNo"
                      v-model="cellTelNo"
                      :rules="rules.cellTelNoRules"
                      label="'-'를 제외하고 입력"
                      mask="###########"
                      single-line
                      color="accent"
                      required
                    ></v-text-field>
                  </td>
                </tr>
              </table>

              <!-- 동의 영역 시작 -->
              <div class="contract1a_agree terms_agree_area">
                <div class="custom-control custom-checkbox allY">
                  <v-checkbox v-if="teleCoCd == '1'" v-model="chk_all" @click.stop="(chk_all = !chk_all), checkAll()" :rules="[(v) => !!v || '약관에 동의해주세요!']">
                    <template v-slot:label>
                      <div id="agree">전체동의</div>
                    </template>
                  </v-checkbox>
                  <v-checkbox
                    v-else
                    v-model="chk_all"
                    style="padding-top:0px;vertical-align: middle; margin-bottom:0px;"
                    @click.stop="(chk_all = !chk_all), checkAll()"
                    :rules="[(v) => !!v || '약관에 동의해주세요!']"
                  >
                    <!-- :rules="[(v) => !!v || '약관에 동의해주세요!']" -->
                    <template v-slot:label>
                      <div id="agree">전체동의</div>
                    </template>
                  </v-checkbox>
                </div>
                <div class="custom-control custom-checkbox">
                  <v-checkbox v-model="chk_a1" hide-details @click.stop="(chk_a1 = !chk_a1), checkBoxCheck()">
                    <template v-slot:label>
                      <div id="a1" v-if="teleCoCd == '1'">서비스 이용약관(필수)</div>
                      <div id="a1" v-if="teleCoCd == '2'">서비스 이용약관(필수)</div>
                      <div id="a1" v-if="teleCoCd == '3'">기본 서비스 이용약관(필수)</div>
                      <div class="text-xs-center" @click.stop="dialog_a1 = true">
                        <span style="font-size: 0.75rem; color: #aaa" class="contract_tos1">(전문보기)</span>
                      </div>
                    </template>
                  </v-checkbox>
                </div>
                <div class="custom-control custom-checkbox">
                  <v-checkbox v-model="chk_a2" hide-details @click.stop="(chk_a2 = !chk_a2), checkBoxCheck()">
                    <template v-slot:label>
                      <div id="a2" v-if="teleCoCd == '1'">개인정보 수집 및 이용동의(필수)</div>
                      <div id="a2" v-if="teleCoCd == '2'">개인정보 수집 및 이용동의(필수)</div>
                      <div id="a2" v-if="teleCoCd == '3'">서비스 이용약관(필수)</div>
                      <div class="text-xs-center" @click.stop="dialog_a2 = true">
                        <span style="font-size: 0.75rem; color: #aaa" class="contract_tos2">(전문보기)</span>
                      </div>
                    </template>
                  </v-checkbox>
                </div>
                <div class="custom-control custom-checkbox">
                  <v-checkbox v-model="chk_a3" hide-details @click.stop="(chk_a3 = !chk_a3), checkBoxCheck()">
                    <template v-slot:label>
                      <div id="a3" v-if="teleCoCd == '1'">개인정보 제3자 제공동의(필수)</div>
                      <!-- <div id="a3" v-if="teleCoCd == '2'">개인정보 제3자 제공동의(필수)</div> -->
                      <div id="a3" v-if="teleCoCd == '2'">KT 개인정보 제3자 제공 동의(필수)</div>
                      <div id="a3" v-if="teleCoCd == '3'">개인정보 수집 및 이용(필수)</div>
                      <div class="text-xs-center" @click.stop="dialog_a3 = true">
                        <span style="font-size: 0.75rem; color: #aaa" class="contract_tos3">(전문보기)</span>
                      </div>
                    </template>
                  </v-checkbox>
                </div>
                <div class="custom-control custom-checkbox">
                  <v-checkbox v-model="chk_a4" hide-details @click.stop="(chk_a4 = !chk_a4), checkBoxCheck()">
                    <template v-slot:label>
                      <div id="a4" v-if="teleCoCd == '1'">금융거래 알림(PUSH 동의)(필수)</div>
                      <div id="a4" v-if="teleCoCd == '2'">금융거래 알림(PUSH 동의)(선택)</div>
                      <div id="a4" v-if="teleCoCd == '3'">개인정보 제3자 제공(필수)</div>
                      <div class="text-xs-center" @click.stop="dialog_a4 = true">
                        <span style="font-size: 0.75rem; color: #aaa" class="contract_tos3">(전문보기)</span>
                      </div>
                    </template>
                  </v-checkbox>
                </div>
                <div class="custom-control custom-checkbox" v-if="teleCoCd != '1'">
                  <v-checkbox v-model="chk_a5" hide-details @click.stop="(chk_a5 = !chk_a5), checkBoxCheck()">
                    <template v-slot:label>
                      <!-- <div id="a4">금융거래 알림(PUSH 동의)(선택)</div> -->
                      <div id="a4" v-if="teleCoCd == '2'">무료보험 가입 동의(선택)</div>
                      <div id="a4" v-if="teleCoCd == '3'">금융거래 알림푸쉬수신(필수)</div>
                      <div class="text-xs-center" @click.stop="dialog_a5 = true">
                        <span style="font-size: 0.75rem; color: #aaa" class="contract_tos3">(전문보기)</span>
                      </div>
                    </template>
                  </v-checkbox>
                </div>
                <!-- 버튼 영역 시작 -->
                <div style="margin:20px auto 0;text-align: center; width:303px;">
                  <vue-recaptcha ref="recaptcha" v-model="recaptchaVerify" @verify="onVerify" @expired="onExpired" :sitekey="$cfg.recaptchaSiteKey"></vue-recaptcha>
                  <div class="v-messages theme--light error--text">
                    <div class="v-messages__wrapper">
                      <div class="v-messages__message" v-if="!recaptchaVerifyCheck" style="text-align: left;">로봇이 아닙니다를 체크하세요!</div>
                    </div>
                  </div>
                </div>
                <div class="form_btn" style="margin-top:10px;">
                  <v-btn id="join_btn" style="color:#fff; font-size:16px margin-left: 0px !improtant" color="#007bff" @click.stop="submit()">가입하기</v-btn>
                  <v-btn id="back_btn" style="color:#fff; font-size:16px margin-left: 0px !improtant" color="#dc3545" @click.stop="$router.push({ name: 'passSafeguardCs' })">돌아가기</v-btn>
                </div>
                <!-- 버튼 영역 끝 -->
              </div>
              <!-- 동의 영역 끝 -->
            </fieldset>
          </v-form>
        </div>
        <div class="contract1a_area_2">
          <p class="cf">
            <span class="para_space bottom_sub_content">-</span>
            <span class="para_space2 bottom_sub_content">매월 2,200원 (VAT포함)</span>
            <!-- <span class="para_space">-</span><span class="para_space2">서비스 가입 전 서비스 이용약관을 반드시 읽어보시기 바랍니다.</span> -->
          </p>
          <p class="cf">
            <!-- <span class="para_space">-</span><span class="para_space2">매월 2,200원 (VAT포함)</span> -->
            <span class="para_space bottom_sub_content">-</span>
            <span class="para_space2 bottom_sub_content">서비스 가입 전 서비스 이용약관을 반드시 읽어보시기 바랍니다.</span>
          </p>
        </div>
      </div>
    </div>
    <!-- 본문 영역 끝-->
    <!-- 서비스 이용약관 시작-->

    <v-dialog v-model="dialog_a1" scrollable width="800">
      <v-card>
        <!-- <v-card-title class="headline">PASS세이프가드 이용약관</v-card-title> -->
        <v-card-text>
          <TermsService v-if="teleCoCd == '1'" />
          <TermsServiceKT v-if="teleCoCd == '2'" />
          <!-- 기본 서비스 이용약관 -->
          <TermsBaseServiceLGT v-if="teleCoCd == '3'" />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click.native="dialog_a1 = false">확인</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 서비스 이용약관 끝-->
    <!-- 개인정보 수집 및 이용동의 시작-->
    <v-dialog v-model="dialog_a2" scrollable width="800">
      <v-card>
        <!-- <v-card-title class="headline">개인정보 수집 및 이용동의</v-card-title> -->
        <v-card-text>
          <TermsPersonal v-if="teleCoCd == '1'" />
          <TermsPersonalKT v-if="teleCoCd == '2'" />
          <!-- 서비스 이용약관 -->
          <TermsServiceLGT v-if="teleCoCd == '3'" />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click.native="dialog_a2 = false">확인</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 개인정보 수집 및 이용동의 끝-->
    <!-- 개인정보 제3자 제동동의 시작-->
    <v-dialog v-model="dialog_a3" scrollable width="800">
      <v-card>
        <!-- <v-card-title class="headline">개인정보 제3자 제동동의</v-card-title> -->
        <v-card-text>
          <TermsPersonalThirdParty v-if="teleCoCd == '1'" />
          <!-- <TermsPersonalThirdPartyKT v-if="teleCoCd == '2'" /> -->
          <TermsKTPersonalThirdPartyKT v-if="teleCoCd == '2'" />
          
          <!-- 개인정보 수집 및 이용동의 -->
          <TermsPersonalLGT v-if="teleCoCd == '3'" />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click.native="dialog_a3 = false">확인</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 개인정보 제3자 제동동의 끝-->
    <!-- 금융거래 알림(PUSH 동의) 시작-->
    <v-dialog v-model="dialog_a4" scrollable width="800">
      <v-card>
        <!-- <v-card-title class="headline">금융거래 알림(PUSH 동의)</v-card-title> -->
        <v-card-text>
          <TermsFinancialAlerts v-if="teleCoCd == '1'" />
          <!-- <TermsKTPersonalThirdPartyKT v-if="teleCoCd == '2'" /> -->
          <TermsFinancialAlertsKT v-if="teleCoCd == '2'" />
          <!-- 개인정보 제3자 제동동의 -->
          <TermsPersonalThirdPartyLGT v-if="teleCoCd == '3'" />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click.native="dialog_a4 = false">확인</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 금융거래 알림(PUSH 동의) 끝--><!-- 금융거래 알림(PUSH 동의) 시작-->
    <v-dialog v-model="dialog_a5" scrollable width="800">
      <v-card>
        <!-- <v-card-title class="headline">금융거래 알림(PUSH 동의)</v-card-title> -->
        <v-card-text>
          <TermsFinancialAlertsKT v-if="teleCoCd == '2'" />
          <!-- 금융거래 알림(PUSH 동의) -->
          <TermsFinancialAlertsLGT v-if="teleCoCd == '3'" />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click.native="dialog_a5 = false">확인</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 금융거래 알림(PUSH 동의) 끝-->
  </div>
</template>
<script>
import TermsService from "../terms/old/TermsService";
import TermsPersonal from "../terms/old/TermsPersonal";
import TermsPersonalThirdParty from "../terms/old/TermsPersonalThirdParty";
import TermsFinancialAlerts from "../terms/old/TermsFinancialAlerts";

import TermsServiceKT from "../terms/kt/TermsServiceKT";
import TermsPersonalKT from "../terms/kt/TermsPersonalKT";
import TermsPersonalThirdPartyKT from "../terms/kt/TermsPersonalThirdPartyKT";
import TermsKTPersonalThirdPartyKT from "../terms/kt/TermsKTPersonalThirdPartyKT";
import TermsFinancialAlertsKT from "../terms/kt/TermsFinancialAlertsKT";
import TermsFreeAnsuranceToJoinKT from "../terms/kt/TermsFreeAnsuranceToJoinKT";

import TermsBaseServiceLGT from "../terms/lg/TermsBaseServiceLGT";
import TermsServiceLGT from "../terms/lg/TermsServiceLGT";
import TermsPersonalLGT from "../terms/lg/TermsPersonalLGT";
import TermsPersonalThirdPartyLGT from "../terms/lg/TermsPersonalThirdPartyLGT";
import TermsFinancialAlertsLGT from "../terms/lg/TermsFinancialAlertsLGT";
// Vue.component('TermsService', termsService)
export default {
  name: "app",
  data: () => ({
    valid: false,
    recaptchaVerify: false,
    recaptchaVerifyCheck: true,
    teleCoCd: "1",
    cellTelNo: "",
    chk_all: false,
    chk_a1: false,
    chk_a2: false,
    chk_a3: false,
    chk_a4: false,
    chk_a5: false,
    chk_a6: false,
    text_a1:
      "이용약관 테스트<br /><br />이용약관 테스트<br /><br />이용약관 테스트<br /><br />이용약관 테스트<br /><br />이용약관 테스트<br /><br />이용약관 테스트<br /><br />이용약관 테스트<br /><br />이용약관 테스트<br /><br />이용약관 테스트<br /><br />이용약관 테스트<br /><br />이용약관 테스트<br /><br />이용약관 테스트<br /><br />이용약관 테스트<br /><br />이용약관 테스트<br /><br />이용약관 테스트<br /><br />이용약관 테스트<br /><br />이용약관 테스트<br /><br />이용약관 테스트<br /><br />이용약관 테스트<br /><br />이용약관 테스트<br /><br />",
    text_a2: "이용약관 테스트<br /><br />이용약관 테스트<br /><br />이용약관 테스트<br /><br />이용약관 테스트<br /><br />이용약관 테스트<br /><br />이용약관 테스트<br /><br />",
    text_a3: "이용약관 테스트<br /><br />이용약관 테스트<br /><br />이용약관 테스트<br /><br />이용약관 테스트<br /><br />이용약관 테스트<br /><br />이용약관 테스트<br /><br />",
    dialog_a1: false,
    dialog_a2: false,
    dialog_a3: false,
    dialog_a4: false,
    dialog_a5: false,
    dialog_a6: false,

    dialog: false,
    rules: {
      cellTelNoRules: [(v) => !!v || "휴대폰번호를 입력하세요.", (v) => (v && v.length >= 11 && /(01[0])([1-9]{1}[0-9]{2,3})([0-9]{4})$/.test(v)) || "휴대폰번호가 정확하지 않습니다."],
      checkBoxRule: [(v) => !!v || '필수 약관에 동의해주세요']
    },
    color: "error",
    mode: "multi-line",
    timeout: 6000
  }),
  components: {
    TermsService,
    TermsPersonal,
    TermsPersonalThirdParty,
    TermsFinancialAlerts,

    TermsServiceKT,
    TermsPersonalKT,
    TermsPersonalThirdPartyKT,
    TermsKTPersonalThirdPartyKT,
    TermsFinancialAlertsKT,
    TermsFreeAnsuranceToJoinKT,

    TermsBaseServiceLGT,
    TermsServiceLGT,
    TermsPersonalLGT,
    TermsPersonalThirdPartyLGT,
    TermsFinancialAlertsLGT
  },
  methods: {
    checkAll() {
      // console.log(this.chk_all);
      this.chk_a1 = this.chk_all;
      this.chk_a2 = this.chk_all;
      this.chk_a3 = this.chk_all;
      this.chk_a4 = this.chk_all;
      if (this.teleCoCd === "1" || this.teleCoCd === "2") {
        this.chk_a5 = this.chk_all;
      }
      if (this.isLGU) {
        this.chk_a5 = this.chk_all;
        this.chk_a6 = this.chk_all;
      }
    },
    checkBoxCheck() {
      if (this.teleCoCd == "1") {
        if (this.chk_a1 && this.chk_a2 && this.chk_a3 && this.chk_a4 && this.chk_a5) {
          this.chk_all = true;
        } else {
          this.chk_all = false;
        }
      } else if (this.teleCoCd == "2") {
        if (this.chk_a1 && this.chk_a2 && this.chk_a3 && this.chk_a4 && this.chk_a5) {
          this.chk_all = true;
        } else {
          this.chk_all = false;
        }
      } else {
        if (this.chk_a1 && this.chk_a2 && this.chk_a3 && this.chk_a4 && this.chk_a5 && this.chk_a6) {
          this.chk_all = true;
        } else {
          this.chk_all = false;
        }
      }
    },
    submit() {
      this.recaptchaVerifyCheck = this.recaptchaVerify;
      this.$refs.form.validate();
      if (!this.valid) {
        return false;
      }
      if (!this.recaptchaVerify) {
        return false;
      }

      if (this.isLGU) {
        // LGT 처리
        this.$router.push({
          name: "passSafeguardIdVerify",
          params: {
            type: "contract",
            teleCoCd: this.teleCoCd == "7" ? "3" : this.teleCoCd,
            cellTelNo: this.cellTelNo,
            mvnoYn: this.mvnoYn
          }
        });
      } else if (this.teleCoCd == "2") {
        // KT 처리
        this.$router.push({
          name: "passSafeGuardCert",
          params: {
            type: "contract",
            teleCoCd: this.teleCoCd,
            cellTelNo: this.cellTelNo,
            agreeYn: this.chk_a4,
            ansuranceAgreeYn: this.chk_a5,
          }
        });
      } else {
        this.$router.push({
          name: "passSafeGuardCert",
          params: {
            type: "contract",
            teleCoCd: this.teleCoCd,
            cellTelNo: this.cellTelNo
          }
        });
      }
    },
    // reCaptcha
    onVerify(r) {
      this.recaptchaVerify = true;
      this.recaptchaVerifyCheck = this.recaptchaVerify;
    },
    onExpired() {
      this.$refs.recaptcha.reset();
    },
    exec() {
      this.$refs.recaptcha.execute();
    },
    reset() {
      this.$refs.recaptcha.reset();
    },
    chkClear() {
      this.chk_a1 = false;
      this.chk_a2 = false;
      this.chk_a3 = false;
      this.chk_a4 = false;
      this.chk_a5 = false;
      this.chk_a6 = false;
      this.chk_all = false;
      this.$refs.form.resetValidation();
    },
    replaceNan(dataNm) {
      this[dataNm] = this[dataNm].replaceAll(/[^0-9]/g, "")
    }
  }
};
</script>

<style>
.v-input--selection-controls__input {
  margin-right: 3px;
}
.custom-checkbox {
  padding: 0px;
}
.v-input--checkbox {
  margin-top: 0px;
  padding-top: 0px;
}
/* .v-chip__content {
  padding-left: 0px;
  font-size: 0.75rem;
  color: #aaa;
  height: 21px !important;
  padding-left: 0px !important;
  padding-right: 0px !important;
  padding-top: 5px !important;
} */
/* .v-label { */
  /* margin-bottom: 0px !important; */
/* } */
.v-card__text {
  font-size: 14px;
}
.theme--light.v-sheet {
  margin: 0 0;
}
/* label { display: inline-block; width: 20%; } */
.realperson-challenge {
  display: inline-block;
}
/* validation check color red */
.v-messages__message {
  color: #ff5252 !important;
}
.v-input__control,
.v-input__slot,
.v-select__slot {
  color: #005df9 !important;
}
.v-input__slot {
  margin: 3px 0 !important;
}
label {
  margin-bottom: 0px !important;
}
.custom-checkbox {
  margin-bottom: 0px;
}
.mdi-radiobox-marked {
  color: #005df9 !important;
}
.mdi-checkbox-marked {
  color: #005df9 !important;
}
</style>
